import type { ElasticListVehicle } from '@//app/api/search/vehicles';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { CreateVehicleSubscriptionVariables } from '@//data/subscriptions/vehicle/useCreateVehicleSubscription';

export interface VehicleSubscriptionElasticVehicle {
  type: 'ElasticVehicle';
  vehicle: ElasticVehicle;
}

export interface VehicleSubscriptionElasticListVehicle {
  type: 'ElasticListVehicle';
  vehicle: ElasticListVehicle;
}

export type SubscriptionItem =
  | VehicleSubscriptionElasticVehicle
  | VehicleSubscriptionElasticListVehicle;

export const createSubscriptionVariables = (
  item: SubscriptionItem,
): CreateVehicleSubscriptionVariables => {
  if (item.type === 'ElasticVehicle') {
    return {
      body: {
        name: item.vehicle.title,
        advertisementId: item.vehicle._id,
        title: item.vehicle.title,
        shortDescription: item.vehicle.shortDescription || '',
        image: item.vehicle.featuredImage?.files?.[0]?.url,
        mileage: item.vehicle.mileage ?? 0,
        price: item.vehicle.price,
        leasingPrice: item.vehicle.leasingPrice ?? 0,
        modelYear: item.vehicle.modelYear,
        fuelType: item.vehicle.fuelType,
        gearboxType: item.vehicle.gearboxType,
        sellerName: '',
        branchName: item.vehicle.branches?.[0]?.name || '',
        latitude: item.vehicle.position?.location.lat ?? 0,
        longitude: item.vehicle.position?.location.lon ?? 0,
        city: item.vehicle.position?.city || '',
        isActive: true,
      },
    };
  }

  return {
    body: {
      name: item.vehicle.title,
      advertisementId: item.vehicle._id,
      title: item.vehicle.title,
      shortDescription: item.vehicle.shortDescription || '',
      image: item.vehicle.featuredImage?.files?.[0]?.url,
      mileage: item.vehicle.mileage ?? 0,
      price: item.vehicle.price,
      leasingPrice: item.vehicle.leasingPrice ?? 0,
      modelYear: item.vehicle.modelYear,
      fuelType: item.vehicle.fuelType,
      gearboxType: item.vehicle.gearboxType,
      sellerName: '',
      branchName: item.vehicle.branches?.[0]?.name || '',
      latitude: item.vehicle.position?.location.lat ?? 0,
      longitude: item.vehicle.position?.location.lon ?? 0,
      city: item.vehicle.position?.city || '',
      isActive: true,
    },
  };
};
